import React, { useState, useRef, useCallback } from "react";
import { Box, Typography, Avatar, Popover, Button } from "@mui/material";
import Video from "./Video";
import user_D from "../../../assets/customerAssets/user_D.jpeg";
import shareIcon from "../../../assets/customerAssets/icons/share.svg";
import moment from "moment/moment";
import VoteComponent from "./VoteComponent";
import ComentBox from "./ComentBox";
import ComentBoxClub from "../common/ComentBoxNew";
import TittleComponent from "./TittleComponent";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
  ThreadsShareButton,
  ThreadsIcon,
  InstapaperShareButton,
  InstapaperIcon,
} from "react-share";
import InstagramWebShare from "../common/share/Instashare";
import GlobalPlayer from "../../GlobalVideoComponent/Index";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ShareComponent from "../common/share/Index";

const GoalComponent = ({ data }) => {

  const formatRelativeDate = useCallback((dateString) => {
    const now = moment();
    const date = moment(dateString);

    // If same day → "Today, 3:45 PM"
    if (now.isSame(date, "day")) {
      return `Today, ${date.format("h:mm A")}`;
    }

    // If yesterday → "Yesterday"
    if (now.diff(date, "days") === 0) {
      // return `Yesterday ${now.diff(date, "hours")} hours ago`;
      return `${now.diff(date, "hours")} hours ago`;
    }

    const diffDays = now.diff(date, "days");
    const diffWeeks = now.diff(date, "weeks");
    const diffMonths = now.diff(date, "months");
    const diffYears = now.diff(date, "years");

    if (diffDays < 7) {
      return diffDays === 1 ? "1 day ago" : `${diffDays} days ago`;
    }

    if (diffWeeks < 5) {
      return diffWeeks === 1 ? "1 week ago" : `${diffWeeks} weeks ago`;
    }

    if (diffMonths < 12) {
      return diffMonths === 1 ? "1 month ago" : `${diffMonths} months ago`;
    }

    return diffYears === 1 ? "1 year ago" : `${diffYears} years ago`;
  }, []);
  const [showMoreTitle, setShowMoreTitle] = useState(false);
  const [sharePop, setSharePop] = useState(null);

  const navigate = useNavigate();

  const shareOpen = Boolean(sharePop);

  const shareUrl = useRef(window.location.href);

  return (
    <>
      <Box className="goal-wrapper">
        <Box className="video-wrapper">
          <Box className="user-wrapper">
            <Box className="user">
              <Avatar
                alt="Remy Sharp"
                src={data?.club_logo || user_D}
                sx={{ width: 48, height: 48 }}
              />
              <Box className="content">
                <Typography component="span">
                  {!data.isTournament
                    ? `Goal scorer: ${data?.ClubGoals[0]?.goal_scorer || data?.title}`
                    : `Tournament: ${data?.title}`}
                </Typography>
                <Typography component="p">
                  {formatRelativeDate(data?.createdAt)}
                </Typography>
              </Box>
            </Box>
          </Box>
          <GlobalPlayer
            link={data?.ClubGoals[0]?.video_link || null}
            thumbnail={data?.ClubGoals[0]?.thumbnail || null}
          />
        </Box>
        <Box className="content-wrapper">
          <Box className="content">
            <Box className="icons">
              <Box className="vote i">
                <VoteComponent
                  id={data?.ClubGoals[0]?.id}
                  count={data?.voteCount}
                  vote={data?.hasVoted}
                  isClub={true}
                  allow={data?.clubMember}
                />
              </Box>

              <Box className="comment i">
                <ComentBoxClub
                  count={data?.commentsCount}
                  id={data?.ClubGoals[0]?.id}
                  api={`clubs/getAllComments/${data?.ClubGoals[0]?.id}`}
                  allow={data?.clubMember}
                />
              </Box>

              <ShareComponent
                data={data}
                title={data?.title}
                shareUrl={`${shareUrl.current}?share=${data.id}`}
              />
            </Box>

            <Box className="details" sx={{ flexDirection: "column" }}>
              <Box className="video-details">
                <Typography component="p">
                  {"Club:- " + data?.title}
                  <span style={{ fontWeight: "bold" }}>
                    {" | " + data?.ClubGoals?.length + " videos"}
                  </span>
                </Typography>
                <Typography component="p">
                  {"City/Town:- " + data?.region}
                </Typography>
                <Typography component="p">
                  {"Uploaded by:- " +
                    data?.ClubGoals[0]?.clubGoalOwner?.fullName}
                </Typography>
                <Typography component="p">
                  {data?.visibility
                    ? "Visibilty:- Public"
                    : "Visibilty:- Private"}
                </Typography>
              </Box>
              <Box className="general-details">
                <Box className="category">
                  <Typography component="p">
                    {"| " + data?.clubCat?.name}
                  </Typography>
                </Box>
                <Box className="title">
                  <TittleComponent title={data?.title} />
                </Box>
              </Box>
            </Box>
            <Box>
              <Button className="custom_primary_button">
                <Typography
                  component="a"
                  onClick={() => {
                    if (data.visibility) {
                      navigate(`/viewClub/${data.id}`);
                    } else {
                      toast.error("Private club. ");
                    }
                  }}
                >
                  {"View Club Details"}
                </Typography>
              </Button>
            </Box>
            <Box className="createdAt">
              {moment(data.createdAt).format("MMM D, YYYY • hh:mm A")}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default GoalComponent;
